export default {"src":"/_next/static/media/announcement.3848fe91.svg","height":36,"width":35,"blurWidth":0,"blurHeight":0};